var mixitup = require('mixitup');

jQuery(function($){


    // Filter
    $filterContainer    = $('#training-filter-form');
    $trainingContainer   = $('#trainings');
    $sortSelect         = $('#sortselect');

    if($filterContainer.length <= 0){
        return;
    }

    console.log('filter init');

    var mixer = mixitup( $trainingContainer, {
        animation: {
            enable: false
        },
        controls: {
            toggleDefault: 'none'
        },
        callbacks: {
            onMixEnd: function(state){
                $('.trainings__filter-status').text(state.totalMatching);

                var $nofilterResults = $('#no-filter-results');

                if(state.totalMatching == '0'){
                    $nofilterResults.show();
                }else{
                    $nofilterResults.hide();
                }

            }
        }
    });


    var currentSelect = '';
    $filterContainer.on('click', '.choices input', function(){
        if (currentSelect !== this) {
            currentSelect = this;
        } else {
            currentSelect = '';
            $(this).prop('checked', false);
            $(this).trigger('change');
        }
    });


    // $("button[type='reset']").on("click", function(evt){
    //     var $form = $(evt.target).closest('form');

    //     evt.preventDefault();

    //     $form.get(0).reset();
    //     // $form.find('select').val('');
    //     $form.find('select.selectpicker').selectpicker('refresh');

    // });


    $('#sortselect').on('change', function(){
        var sortValue = $(this).val();

        mixer.sort(sortValue);
    });


    $filterContainer.on( "submit", function(evt){

        var $form = $(evt.target);

        evt.preventDefault();

        console.trace("submit handler");

        $('#modal--filter').hide();

        var filterData = {};

        $($form.serializeArray()).each(function(index, obj){
            filterData[obj.name] = obj.value;
        });



        mixer.filter($trainingContainer.children().filter(function(index, el){

            //specific filter data
            var $el = $(el);
            var elData = $el.data();

            var include = true;

            if(filterData.q){
                include = include && ($el.text().toLowerCase().indexOf(filterData.q.toLowerCase()) > -1);
            }

            if(filterData.region){
                 if(typeof elData.region != 'undefined') {
                    include = include && (elData.region.indexOf(filterData.region) !== -1);
                }
            }

            if(filterData.dates && typeof elData.dates != 'undefined'){
                var dateFound = false;

                if(elData.dates) {
                    var elDates = elData.dates.split(' ');
                    var filterDates = filterData.dates.split(' - ');

                    if(filterDates.length == 2) {
                        var startDate = $.datepicker.parseDate('dd/mm/yy', filterDates[0]);
                        var endDate = $.datepicker.parseDate('dd/mm/yy', filterDates[1]);

                        $(elDates).each(function(i, elDate) {
                            var date = $.datepicker.parseDate('dd/mm/yy', elDate);

                            if(date >= startDate && date <= endDate) {
                                dateFound = true;
                            }
                        });
                    }

                    if(filterDates.length == 1) {
                        var startDate = $.datepicker.parseDate('dd/mm/yy', filterDates[0]);

                        $(elDates).each(function(i, elDate) {
                            var date = $.datepicker.parseDate('dd/mm/yy', elDate);

                            if(date.getTime() == startDate.getTime()) {
                                dateFound = true;
                            }
                        });
                    }
                }

                include = include && (dateFound);
            }

            if(filterData.day_count){
                switch(filterData.day_count){
                    case '1':
                        include = include && (elData.day_count == 1);
                        break;
                    case '>1':
                        include = include && (elData.day_count > 1);
                        break;
                    case '>2':
                        include = include && (elData.day_count > 2);
                        break;
                }
            }

            if(filterData.intake_mandatory){
                include = include && elData.intake_mandatory;
            }

            if(filterData.career_dialog_mandatory){
                include = include && elData.career_dialog_mandatory;
            }

            return include;
        }));

    } );

    var prevFilled = false;

    $filterContainer.find('[name=who], [name=discipline], [name=q]').each(function(index, elm){
        if($(elm).val() != ''){
            prevFilled = true;
        }
    });

    if(prevFilled){
        $filterContainer.submit();
    }

    $filterContainer.on('change', function(evt, ui){


        if($(evt.target).closest('.modal').length == 0){
            $filterContainer.submit();
        }
    });

    // Einde filter


});